package com.patronat.top.client

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import com.patronat.top.client.deeplink.openClientDeepLink
import io.github.aakira.napier.DebugAntilog
import io.github.aakira.napier.Napier
import kotlinx.browser.document
import kotlinx.browser.window

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    Napier.base(DebugAntilog())
    openClientDeepLink(window.location.href)

    val body = document.body ?: return
    body.style.setProperty("margin", "0")
    body.style.setProperty("padding", "0")
    body.style.setProperty("width", "100%")
    body.style.setProperty("height", "100%")
    body.style.setProperty("overflow", "hidden")

    ComposeViewport(viewportContainer = body) {
        ClientApp(webMode = true)
    }
}
